import type {
  IPublishQuestion,
  IPublishSubQuestion,
  IQuestionSet,
  ISetSubQuestion,
  PercorsoIntervista,
} from '../models';

// Percorsi visibili nell'app (card /profondita, select admin, voci nuove). 'media' esiste ancora a
// DB e nel tipo (interviste storiche) ma è nascosto qui, solo FE (22/09/2026): per riattivarlo
// basta rimetterlo in lista e ripristinare la regola in proposePercorso. 'veloce' (30/10/2026) è
// qui ma proposePercorso non lo restituisce mai: si sceglie solo a mano.
export const PERCORSI_INTERVISTA: readonly PercorsoIntervista[] = ['parziale', 'completa', 'veloce'];

// Voce vuota per "Aggiungi": attiva in tutti i percorsi, così non sparisce per dimenticanza.
export const mkVoce = (code: string): IPublishSubQuestion => ({
  code,
  text: '',
  text_sintetico: null,
  is_image: false,
  has_textbox: true,
  images: [],
  percorsi: PERCORSI_INTERVISTA.map((p) => ({ code: p, is_sintetico: false })),
  ambienti: [],
  impianti: [],
});

// Set pubblicato → draft editabile (stessi campi meno gli id/sort_order assegnati dal DB).
export const toDraft = (set: IQuestionSet): IPublishQuestion[] => {
  const voce = (v: ISetSubQuestion): IPublishSubQuestion => ({
    code: v.code,
    text: v.text,
    text_sintetico: v.text_sintetico,
    is_image: v.is_image,
    has_textbox: v.has_textbox,
    images: v.images.map((im) => ({ image_path: im.image_path, caption: im.caption })),
    percorsi: v.percorsi.map((p) => ({ code: p.code, is_sintetico: p.is_sintetico })),
    ambienti: [...v.ambienti],
    impianti: [...v.impianti],
  });
  return set.questions.map((q) => ({
    ...voce(q),
    tag: q.tag,
    title: q.title,
    sub_questions: q.sub_questions.map(voce),
  }));
};

// Sposta l'elemento da `from` a `to` (riordino con frecce su/giù). Fuori range = lista intatta.
export const moveItem = <T>(list: readonly T[], from: number, to: number): T[] => {
  if (from < 0 || to < 0 || from >= list.length || to >= list.length) {
    return [...list];
  }
  const out = [...list];
  const [moved] = out.splice(from, 1);
  out.splice(to, 0, moved);
  return out;
};

// Codici duplicati tra domande e sottodomande: il DB li rifiuta, meglio dirlo prima.
export const duplicateCodes = (questions: readonly IPublishQuestion[]): string[] => {
  const seen = new Map<string, number>();
  for (const q of questions) {
    for (const v of [q, ...(q.sub_questions ?? [])]) {
      seen.set(v.code, (seen.get(v.code) ?? 0) + 1);
    }
  }
  return [...seen.entries()].filter(([, n]) => n > 1).map(([code]) => code);
};
